// extracted by mini-css-extract-plugin
module.exports = {"label":"styles_label__3W1ti","button":"styles_button__372fH"};